import React from "react";
import HowItWorksHero from "./sections/HowItWorksHero/HowItWorksHero";
import ProcessFunnel from "./sections/ProcessFunnel/ProcessFunnel";
import ProcessDetails from "./sections/ProcessDetails/ProcessDetails";
import PerformanceModel from "./sections/PerformanceModel/PerformanceModel";
import HowItWorksCTA from "./sections/HowItWorksCTA/HowItWorksCTA";
import "./HowItWorks.css";

const HowItWorks = () => {
  return (
    <div className="how-it-works-page">
      <HowItWorksHero />
      <ProcessFunnel />
      <ProcessDetails />
      <PerformanceModel />
      <HowItWorksCTA />
    </div>
  );
};

export default HowItWorks;
